import {Button as BaseButton} from './button/button';
import {Contained} from './contained/contained';
import {Icon} from './icon';
import {Link} from './link/link';
import {Outlined} from './outlined/outlined';
import {HideButton} from './special/hide';
import {Text} from './text/text';
import {ButtonProps as ExportedButtonProps} from './types';

export const Buttons = {
	Gray: BaseButton,
	Contained,
	Outlined,
	Text,
	Link,
	Icon,
};

export type ButtonProps = ExportedButtonProps;

export const SpecialButtons = {
	Hide: HideButton,
};
export * from './types';
